export default {
    gamesKilled: 20,
    gamesOnDeathRow: 20,
    studiosKilled: 20,
    sins: 20
}